var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c("v-time-picker", {
        attrs: { format: "24hr", landscape: "" },
        nativeOn: {
          mouseup: function ($event) {
            $event.stopPropagation()
            return _vm.updateField()
          },
        },
        model: {
          value: _vm.input,
          callback: function ($$v) {
            _vm.input = $$v
          },
          expression: "input",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }